const usersBackofficeRoutes = [
  {
    path: '',
    name: 'Users',
    meta: {
      title: {
        en: 'Users',
        ru: 'Пользователи',
      },
      authorize: [],
    },
    component: () => import(/* webpackChunkName: 'BackofficeUsers' */ '../components/pages/BackofficeUsers.vue'),
  },
  {
    path: ':_id',
    name: 'User Profile',
    meta: {
      title: {
        en: 'Profile Settings',
        ru: 'Настройки профиля',
      },
    },
    component: () => import(/* webpackChunkName: 'BackofficeUserProfileEdit' */ '../components/pages/ProfileEdit.vue'),
    children: [
      {
        path: '',
        name: 'Profile Edit Profile',
        component: () => import(/* webpackChunkName: 'BackofficeUserProfileEditProfile' */ '../components/pages/ProfileEditProfile.vue'),
      },
      {
        path: 'account',
        name: 'Profile Edit Account',
        component: () => import(/* webpackChunkName: 'BackofficeUserProfileEditAccount' */ '../components/pages/ProfileEditAccount.vue'),
      },
    ],
  },
];

export default usersBackofficeRoutes;
